import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TipologiaCostruttiva } from '../models/tipologia-costruttiva';
import { ResourcefulService } from './resourcefulService';



@Injectable({
    providedIn: 'root'
})
export class TipologiaCostruttivaService extends ResourcefulService<TipologiaCostruttiva>{
    constructor(private httpClient: HttpClient) {
        super(httpClient, TipologiaCostruttiva);
    }
}
